import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/user/Login'
import app from '../main'
import Users from '../views/user/Users'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !app.config.globalProperties.$cookies.get('bearerToken')) next({ name: 'Login' })
  if (to.name === 'Login' && app.config.globalProperties.$cookies.get('bearerToken')) next({ name: 'Dashboard' })
  else next()
})

export default router
